<template>
  <Button
    v-if="showWaitlistButton"
    color="primary"
    variant="outlined"
    data-test-id="buy-box-waitlist-button"
    class="px-2 py-1 rounded-md grow text-xs flex items-center hover:bg-white hover:text-teal-900"
    @click="handleClick"
  >
    <BellIcon />
    <span v-show="displayLabel" ref="waitlistLabel" class="ml-1">
      {{ $t('product.show.noAvailableDatesBox.ctaTextOnlyWaitlist') }}
    </span>
  </Button>
</template>
<script lang="ts" setup>
import BellIcon from '@/public/icons/bell.svg?component'
import type { EventDescription } from '~/composables/types/event'

const { toggleWaitlistSidebar } = useUiState()
const eventData = inject('eventData') as EventDescription
const emit = defineEmits(['click:waitlist'])
const waitlistLabel = ref()

const { displayLabel = true } = defineProps<{
  displayLabel?: boolean
}>()

const showWaitlistButton = computed(() =>
  eventGetters.isWaitlistActive(eventData)
)

const handleClick = () => {
  emit('click:waitlist')
  toggleWaitlistSidebar()
}
</script>
